export default __webpack_public_path__ + "static/media/rifles.f64c479a.svg";